module.exports = __webpack_public_path__ + "img/yeso_lanzable_para_muros.ce51af8d.png";